var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-view"},[(_vm.isLoading)?_c('SkeletonHome'):[_c('BaseHeader'),_c('main',{staticClass:"home-view__main",class:_vm.mainClass},[_c('Transition',{attrs:{"name":"transition-1"}},[_c(_vm.componentActive,{tag:"Component"})],1)],1)],_c('BaseFooter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }